import {createStore, combineReducers, applyMiddleware} from 'redux';
import { routerReducer } from 'react-router-redux';
import thunk from "redux-thunk";
import * as API from 'api';
import {categoriesAsTree, categoriesToHash} from 'base/reducers/categories';
import {listBusinesses} from 'base/reducers/businesses';
import {listConsultingCategories} from 'base/reducers/consulting-categories';
import {listHomeBanners} from 'base/reducers/home-banners';
import {auth} from 'base/reducers/auth';
import {menu} from 'base/reducers/menu';
import {fairs} from 'base/reducers/fairs';
import {notification} from 'base/reducers/notifications';
import {reducer as toastrReducer} from 'react-redux-toastr';
import conversationMessages from './conversation-messages';

let rootReducer = combineReducers({
  categoriesAsTree: categoriesAsTree,
  categoryHash: categoriesToHash,
  listBusinesses,
  routing: routerReducer,
  auth,
  notification,
  menu,
  fairs,
  toastr: toastrReducer,
  conversationMessages,
  listConsultingCategories,
  listHomeBanners
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export {store, rootReducer};



// WEBPACK FOOTER //
// ./reducers/index.js